import React, { useEffect, useState } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import moment from 'moment';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';

function VerifyTransaction() {
  const [data, setData] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const Verify = async (id, pin_number) => {
    try {
      //const response = await axios.post("/remittance/verify/transaction", { id, pin_number });
      const response = await axios.post("/prabhuRemittance/verifyTransaction", { id, pin_number });
      const { status, message } = response.data;
      if (status) {
        setRefresh(!refresh);
        swal("Success", message, "success");
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        swal("Error", error.response.data.message, "error");
      }
    }
  };

  const getData = async () => {
    try {
      const response = await axios.get("/remittance/request/all");
      const { status, details } = response.data;
      if (status) {
        setData(details);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    getData();
  }, [refresh]);

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              {
                data && (
                  <>
                    <h4 class="card-title">
                      Transactions
                    </h4>
                    <DataTable
                      value={data}
                      size="small"
                      className="custom-table"
                    >
                      <Column
                        field="index"
                        header="#"
                        sortable
                        body={(rowData, { rowIndex }) => <span data-label="#">{rowIndex + 1}</span>}
                      />
                      <Column
                        field="created_at"
                        header="Date"
                        sortable
                        body={(rowData) => <span data-label="Date">{moment(rowData.created_at).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                      />
                      <Column
                        field="sender"
                        header="Sender"
                        sortable
                        body={(rowData) => <span data-label="Sender">{rowData?.sender?.name}<br />({rowData?.sender?.mobile})</span>}
                      />
                      <Column
                        field="send_amount"
                        header="Amount(₹)"
                        sortable
                        body={(rowData) => <span data-label="Amount(₹)">{rowData.send_amount}</span>}
                      />
                      <Column
                        field="service_charge"
                        header="Service Charge(₹)"
                        sortable
                        body={(rowData) => <span data-label="Service Charge(₹)">{rowData?.service_charge}</span>}
                      />

                      <Column
                        field="p_transaction_pin"
                        header="Pin Number"
                        sortable
                        body={(rowData) => <span data-label="Pin Number">{rowData?.p_transaction_pin}</span>}
                      />
                      <Column
                        field="receiver"
                        header="Reciever"
                        sortable
                        body={(rowData) => <span data-label="Reciever">{rowData?.receiver?.receiver_name}<br />({rowData?.receiver?.receiver_mobile})</span>}
                      />
                      <Column
                        field="status"
                        header="Status"
                        sortable
                        body={(rowData) => <span data-label="Status">{rowData?.status}</span>}
                      />

                      <Column
                        field="action"
                        header="Action"
                        sortable
                        body={
                          (rowData) => (
                            <span data-label="Action">
                              <button className="btn btn-primary" onClick={(e) => Verify(rowData?._id, rowData?.p_transaction_pin)}>Verify</button>
                            </span>
                          )
                        }
                      />
                    </DataTable>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyTransaction;
